import { paymentActions } from "./actions";
import { IMerchantDetails, IPaymentState } from "./interface";

export const paymentInitialState: IPaymentState = {
  merchantDetailsMap: {},
  planData: [],
  loaders: {
    addMerchantDetails: false,
    getMerchantDetails: false,
    getMerchantDetailsByIds: false,
    submitPayment: false,
    planData: false,
  },
  errors: {
    addMerchantDetails: "",
    getMerchantDetails: "",
    getMerchantDetailsByIds: "",
    submitPayment: "",
    planData: "",
  },
};

export const paymentReducer = (
  state: IPaymentState = paymentInitialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case paymentActions.FETCH_PLANS_DATA: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          planData: true,
        },
        errors: {
          ...state.errors,
          planData: "",
        },
      };
    }

    case paymentActions.FETCH_PLANS_DATA_SUCCESS: {
      return {
        ...state,
        planData: action.payload.planDetails,
        loaders: {
          ...state.loaders,
          planData: false,
        },
        errors: {
          ...state.errors,
          planData: "",
        },
      };
    }

    case paymentActions.FETCH_PLANS_DATA_FAILURE: {
      return {
        ...state,
        planData: action.payload,
        loaders: {
          ...state.loaders,
          planData: false,
        },
        errors: {
          ...state.errors,
          addMerchantDetails: action.payload.error,
        },
      };
    }

    case paymentActions.ADD_MERCHANT_DETAILS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addMerchantDetails: true,
        },
        errors: {
          ...state.errors,
          addMerchantDetails: "",
        },
      };
    }

    case paymentActions.ADD_MERCHANT_DETAILS_SUCCESS: {
      {
        const merchantDetails = action.payload.merchantDetails;
        const { paymentId } = merchantDetails;
        const existingMerchantDetailsMap = {
          ...(state.merchantDetailsMap ?? {}),
        };
        existingMerchantDetailsMap[paymentId] = merchantDetails;
        return {
          ...state,
          merchantDetailsMap: existingMerchantDetailsMap,
          loaders: {
            ...state.loaders,
            addMerchantDetails: false,
          },
        };
      }
    }

    case paymentActions.ADD_MERCHANT_DETAILS_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addMerchantDetails: false,
        },
        errors: {
          ...state.errors,
          addMerchantDetails: action.payload.error,
        },
      };
    }

    case paymentActions.GET_MERCHANT_DETAILS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getMerchantDetails: true,
        },
        errors: {
          ...state.errors,
          getMerchantDetails: "",
        },
      };
    }

    case paymentActions.GET_MERCHANT_DETAILS_SUCCESS: {
      {
        const merchantDetails = action.payload.merchantDetails ?? [];
        const existingMerchantDetailsMap = {
          ...(state.merchantDetailsMap ?? {}),
        };

        merchantDetails?.forEach((merchantDetail: IMerchantDetails) => {
          const paymentId = merchantDetail?.paymentId;
          existingMerchantDetailsMap[paymentId] = merchantDetail;
        });

        return {
          ...state,
          merchantDetailsMap: existingMerchantDetailsMap,
          loaders: {
            ...state.loaders,
            getMerchantDetails: false,
          },
        };
      }
    }

    case paymentActions.GET_MERCHANT_DETAILS_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getMerchantDetails: false,
        },
        errors: {
          ...state.errors,
          getMerchantDetails: action.payload.error,
        },
      };
    }

    case paymentActions.SUBMIT_PAYMENT: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          submitPayment: true,
        },
        errors: {
          ...state.errors,
          submitPayment: "",
        },
      };
    }

    case paymentActions.SUBMIT_PAYMENT_SUCCESS: {
      {
        return {
          ...state,
          loaders: {
            ...state.loaders,
            submitPayment: false,
          },
        };
      }
    }

    case paymentActions.SUBMIT_PAYMENT_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          submitPayment: false,
        },
        errors: {
          ...state.errors,
          submitPayment: action.payload.error,
        },
      };
    }

    case paymentActions.GET_MERCHANT_DETAILS_BY_IDS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getMerchantDetailsByIds: true,
        },
        errors: {
          ...state.errors,
          getMerchantDetailsByIds: "",
        },
      };
    }

    case paymentActions.GET_MERCHANT_DETAILS_BY_IDS_SUCCESS: {
      {
        const merchantDetails: IMerchantDetails[] =
          action.payload.merchantDetails ?? [];
        const existingMerchantDetailsMap = {
          ...(state.merchantDetailsMap ?? {}),
        };

        for (const merchantDetail of merchantDetails) {
          const paymentId = merchantDetail?.paymentId;
          existingMerchantDetailsMap[paymentId] = merchantDetail;
        }

        return {
          ...state,
          merchantDetailsMap: existingMerchantDetailsMap,
          loaders: {
            ...state.loaders,
            getMerchantDetailsByIds: false,
          },
        };
      }
    }

    case paymentActions.GET_MERCHANT_DETAILS_BY_IDS_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getMerchantDetailsByIds: false,
        },
        errors: {
          ...state.errors,
          getMerchantDetailsByIds: action.payload.error,
        },
      };
    }

    default:
      return { ...state };
  }
};
